import React,{ useState, useRef,useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { ThemeContext } from '../context/ThemeContext';


function Navbar() {
  const navRef = useRef();
  const  [navCondition,setNavCondition] = useState(false);
  const theme = useContext(ThemeContext);

  function toggleNav(condition){

    //console.log(theme);
    if(theme.state.width < 768){
    navCondition === true ? setNavCondition(false) : setNavCondition(true);
    if(navCondition === true){
      document.body.classList.remove('body-nav-true','body-nav-false');
      document.body.classList.add('body-nav-false');
  }else{
    document.body.classList.remove('body-nav-true','body-nav-false');
    document.body.classList.add('body-nav-true');
    }
}
}

  return (
    <>

    <nav className={"w-full h-[20px] margin-auto flex px-0 items-center relative  open-" + navCondition}>

        <ul style={{maxWidth:1380+'px'}} ref={navRef} className={ 'nav nav-' + navCondition +" w-full md:px-2 md:flex absolute md:relative top-full left-0 right-0 z-200"}>

            <li className="md:ml-[200px] px-2.5 md:mt-[60px]">
            <NavLink onClick={() => toggleNav() } aria-label="Cinema" to="/#proyectos" className="flex md:inline-flex py-4 px-.5 md:px-2.5 lg:px-4.5 colorChange text-white tracking-normal items-center">
                <span className="roboto-bold mt-.5 uppercase font-medium">Proyectos</span>
              </NavLink>
          </li>
          <li className="px-2.5 md:mt-[60px]">
          <NavLink onClick={() => toggleNav() } aria-label="Television" to="/#servicios" className="flex md:inline-flex py-4 px-.5 md:px-2.5 lg:px-4.5 colorChange text-white tracking-normal items-center">
              <span className="roboto-bold mt-.5 uppercase font-medium">servicios</span>
            </NavLink>
        </li>

       {/*  <li className="px-2.5 md:mt-[60px]">
        <NavLink onClick={() => toggleNav() } to="/#news" className="flex md:inline-flex py-4 px-.5 md:px-2.5 lg:px-4.5 colorChange text-white tracking-normal items-center">
            <span className="roboto-bold mt-.5 uppercase font-medium">Noticias</span>
          </NavLink>
      </li>*/}
      <li className="px-2.5 md:mt-[60px]">
      <NavLink onClick={() => toggleNav() } aria-label="Contacto" className="flex md:inline-flex py-4 px-.5 md:px-2.5 lg:px-4.5 colorChange text-white tracking-normal items-center" to={"/#contacto"}>
              <span className="roboto-bold mt-.5 uppercase font-medium">Contacto</span>
      </NavLink>
      </li>

      <li style={{marginTop:'3px',marhinRight: 3+'px'}} className="ml-auto social px-2 flex inline-flex justify-center items-center">
        <a href="https://www.instagram.com/matchpointservice/" className="text-white">
  <span className="">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 448 512"
      width="26">

      <path
        d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
    </svg>
  </span>
</a>
      </li>

      <li style={{marginTop:'3px',paddingRight: 3+'px'}} className="social px-1 flex inline-flex justify-center items-center ml-[12px] mr-[8px]">
        <a href="https://www.linkedin.com/company/matchpointservice/" className="text-white">
          <span className="">
            <svg xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 448 512"
              width="26">
                <path
                  d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" />
              </svg>
          </span>
        </a>
      </li>

      {/*<li style={{marginTop:'-1px',paddingRight: 6+'px'}} className="social tiktok px-1 pl-0 flex inline-flex justify-center items-center ml-[15px] mr-[8px]">
        <a href="https://www.tiktok.com/@matchpointservice" className="text-white">
  <span className="">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 400 512"
      width="29"
    height="29">
      <path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"/></svg>
  </span>
</a>
      </li>*/}

  {/*    <li className="px-1 flex inline-flex justify-center items-center">
        <button type="button" className="text-white">
  <span className="[&>svg]:h-8 [&>svg]:w-10">
    <svg xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 100 100">
      <g id="Layer_3"/><g id="Layer_1"><g id="IMDB"><g><path d="M73.2,23.4c1.5,0.1,2.6,1.3,2.6,2.8v48c0,1.5-1.1,2.7-2.6,2.8H24.7c-1.4-0.1-2.5-1.2-2.6-2.6V26c0.1-1.4,1.2-2.5,2.6-2.6     H73.2 M73.2,22.2H24.8l-0.1,0c-2,0.1-3.6,1.7-3.7,3.7l0,0.1v48.4l0,0.1c0.1,2,1.7,3.5,3.6,3.7l0.1,0h48.5l0.1,0     c2-0.2,3.6-1.9,3.6-4v-48C77,24.1,75.4,22.4,73.2,22.2L73.2,22.2z"/></g><rect  height="17.2" width="4.4" x="27.8" y="41.5"/><path  d="M41.7,41.5l-1,8L40,45.2c-0.2-1.4-0.4-2.6-0.5-3.7h-5.8v17.2h3.9l0-11.3l1.6,11.3H42l1.6-11.6v11.6h3.9V41.5    H41.7z"/><path  d="M54.3,58.7c1.1,0,1.9-0.1,2.4-0.2c0.5-0.1,1-0.3,1.3-0.6c0.4-0.3,0.6-0.7,0.8-1.2c0.1-0.5,0.2-1.6,0.2-3.1v-6    c0-1.6-0.1-2.7-0.2-3.3c-0.1-0.6-0.3-1.1-0.7-1.5c-0.4-0.5-1-0.8-1.7-1c-0.7-0.2-2-0.3-4.1-0.3H49v17.2H54.3z M54.4,44.6    c0.2,0.1,0.3,0.3,0.3,0.5c0.1,0.2,0.1,0.7,0.1,1.5v6.7c0,1.1-0.1,1.8-0.2,2.1c-0.1,0.3-0.5,0.4-1.2,0.4V44.5    C53.9,44.5,54.2,44.5,54.4,44.6z"/><path  d="M60.6,41.5v17.2h4l0.3-1.1c0.4,0.4,0.8,0.8,1.2,1c0.4,0.2,1.1,0.3,1.6,0.3c0.7,0,1.3-0.2,1.8-0.6    c0.5-0.4,0.8-0.8,1-1.3c0.1-0.5,0.2-1.3,0.2-2.3v-4.8c0-1,0-1.7-0.1-2c0-0.3-0.2-0.6-0.4-1c-0.2-0.3-0.6-0.6-1-0.8    c-0.4-0.2-0.9-0.3-1.5-0.3c-0.5,0-1.2,0.1-1.6,0.3c-0.4,0.2-0.8,0.5-1.2,0.9v-5.6H60.6z M66.3,54.5c0,0.8,0,1.3-0.1,1.6    c-0.1,0.2-0.4,0.3-0.7,0.3c-0.3,0-0.4-0.1-0.5-0.3c-0.1-0.2-0.1-0.7-0.1-1.5v-4.5c0-0.8,0-1.3,0.1-1.5c0.1-0.2,0.3-0.3,0.5-0.3    c0.3,0,0.6,0.1,0.7,0.3c0.1,0.2,0.1,0.7,0.1,1.4V54.5z"/></g></g></svg>
  </span>
</button>
      </li>
      */}



        </ul>

        <div style={{zIndex:1000}} className="pr-8 pt-16 ml-auto md:hidden text-white cursor-pointer">
          <a onClick={() => toggleNav() } href="#nav" className="colorChange text-white" aria-label="mobile navigation menu">
            <svg width="32" className={"w-10 h-8 navBtn open-" + navCondition}
              xmlns="http://www.w3.org/2000/svg"
              fill="#fff"
              viewBox="0 0 28 28">
                <g>

<rect  className="bar_1" height="2" width="32" x="0.5" y="0"/>

<rect  className="bar_2" height="2" width="32" x="0.5" y="7"/>

<rect  className="bar_3" height="2" width="32" x="0.5" y="14"/>

</g>            </svg>
          </a>
      </div>
    </nav>
</>
  )
}

export default Navbar
